/**
 * Centralized styling constants and shared icons for MediaPlayerV2 controls
 */

/** Hover background color for all media player control buttons */
export const CONTROL_HOVER_BG = "blue.500";

/** Active/pressed background color for all media player control buttons */
export const CONTROL_ACTIVE_BG = "blue.600";

// ============================================================================
// Video Camera Icons
// ============================================================================
export { HiOutlineVideoCamera as IconShowVideo } from "react-icons/hi2";
export {
  LuVideoOff as IconHideVideo,
  LuVideoOff as IconNoVideo,
} from "react-icons/lu";

// ============================================================================
// Action Bar Icons
// ============================================================================
export {
  IoFlagOutline as IconFlag,
  IoChatbubbleOutline as IconNote,
  IoStarOutline as IconStar,
} from "react-icons/io5";
export { RiScissorsFill as IconClip } from "react-icons/ri";

// ============================================================================
// Playback Control Icons (from lucide-react)
// ============================================================================
export { Pause as IconPause, Play as IconPlay } from "lucide-react";

// ============================================================================
// Volume Control Icons (from lucide-react)
// ============================================================================
export { VolumeX as IconMute, Volume2 as IconVolume } from "lucide-react";

// ============================================================================
// Fullscreen/PIP Icons (from lucide-react)
// ============================================================================
export {
  Minimize2 as IconExitFullscreen,
  Fullscreen as IconFullscreen,
  PictureInPicture2 as IconPictureInPicture,
} from "lucide-react";

// ============================================================================
// Other Icons
// ============================================================================
export { HiDotsVertical as IconMoreActions } from "react-icons/hi";

// Re-export IconPlayMobile from components/Icons
export { IconPlayMobile } from "../../../components";
